import React from 'react';
import { Link } from 'react-router-dom';
import ReactLoader from 'utils/react-loader';
import CreateReactClass from 'create-react-class';

import RuntimeGetters from 'data/app-runtime/getters';
import FamilyReport from './family-report';

import Reactor from 'data/reactor';
import Getters from 'data/getters';
import Actions from 'data/actions';
import DataLoader from 'data/loader';
import DropdownMenu from 'components/generic/controls/dropdown-menu';
import FeatureUtils from 'utils/features';
import CommonValues from 'resources/common-values';
import withRouter from '../ComponentWithRouterProp';
import { onStudentSelectionEnter } from '../../loaderFunction';

import './student-selection.less';

export default withRouter(
    CreateReactClass({
        displayName: 'student-selection',
        mixins: [Reactor.ReactMixin],

        getInitialState() {
            onStudentSelectionEnter();
        },

        getDataBindings() {
            return {
                linkingStudies: Getters.partner.linkingStudies,
                terms: Getters.partner.terms,
                schools: Getters.roster.schools,
                instructors: Getters.roster.instructors,
                classes: Getters.roster.classes,
                students: Getters.roster.students,
                selectedTermBid: Getters.roster.selectedTermBid,
                selectedSchoolBid: Getters.roster.selectedSchoolBid,
                selectedInstructorBid: Getters.roster.selectedInstructorBid,
                selectedClassBid: Getters.roster.selectedClassBid,
                selectedClass: Getters.roster.selectedClass,
                selectedSubject: RuntimeGetters.selectedSubject,
                selectedStudentBid: Getters.roster.selectedStudentBid,
                currentlyShowingStudentBid: Getters.roster.selectedStudentBid,
                profileCheckCompleted: Getters.user.profileCheckCompleted,
                reportsQueueLink: Getters.user.reportsQueueLink,
                studentInfo: Getters.student.studentInfoForCurrentStudentBid,
                selectedTermNumber: Getters.student.currentlySelectedTermNumber,
                termsWithTestEvents: Getters.student.termsWithTestEventsForStudent,
                pageAlert: Getters.runtime.pageAlert,
            };
        },

        componentDidMount() {
            // The following ensures that the selected term and expanded module settings
            // for the previously showing student (if there was one) are reset
            // (needed when navigating back to selection screen from student profile screen)
            if (this.state.currentlyShowingStudentBid) {
                setTimeout(() => {
                    Reactor.batch(() => {
                        Actions.student.changeSelectedTermNumber(
                            this.state.currentlyShowingStudentBid,
                            CommonValues.mostRecentTermNumber
                        );
                        Actions.runtime.expandModule(null, null, false);
                    });
                }, 1);
            }
            // Removes any GOT popover settings that might exist from previously viewed student
            nweaGlobals.chartPopover = { popoverName: null, chart: null };
        },

        /*  Commenting this out as per 173731
    componentDidUpdate() {
        if (!this.state.selectedStudentBid && !this.state.students.isEmpty()) { // If we have student data, but none are selected...
            const studentBid = this.state.students.first().get("studentBid", ""); // then proactively load the first student in listing.
            setTimeout(() => { DataLoader.loadStudentData(studentBid) }, 1);
        }
    },*/

        changeTerm(termBid) {
            Actions.roster.selectRosterTermBid(termBid);
            DataLoader.loadSchoolsForTerm(termBid);
            this.setState({
                classSelected: false,
            });
        },

        changeSchool(schoolBid) {
            Actions.roster.selectSchoolBid(schoolBid);
            DataLoader.loadInstructorsForSchool(this.state.selectedTermBid, schoolBid);
            this.setState({
                classSelected: false,
            });
        },

        changeInstructor(instructorBid) {
            Actions.roster.selectInstructorBid(instructorBid);
            DataLoader.loadClassesForInstructor(
                this.state.selectedTermBid,
                this.state.selectedSchoolBid,
                instructorBid
            );
            this.setState({
                classSelected: false,
            });
        },

        changeClass(classBid) {
            Actions.roster.selectClassBid(classBid);
            const finishedLoading = (students) => {
                if (this.props.location.pathname === '/family-report') {
                    Actions.roster.selectStudentBid(students[0].studentBid);
                    DataLoader.loadStudents(students[0].studentBid);
                }
            };
            DataLoader.loadStudentsForClass(
                this.state.selectedTermBid,
                this.state.selectedSchoolBid,
                classBid,
                finishedLoading
            );
            this.setState({
                classSelected: true,
            });
            if (this.state.clearSelectedStudents) {
                this.state.clearSelectedStudents();
            }
        },

        changeStudent(studentBid) {
            Actions.roster.selectStudentBid(studentBid);
            /*      Commenting this out as per 173731
        DataLoader.loadStudents(studentBid);
*/
        },

        setClearSelectedStudents(callback) {
            this.setState({
                clearSelectedStudents: callback,
            });
        },

        autoloadOnClick() {
            const timeout = 150;
            const termBid = process.env.mockTermBid;
            const schoolBid = process.env.mockSchoolBid;
            const instructorBid = process.env.mockInstructorBid;
            const classBid = process.env.mockClassBid;

            setTimeout(() => {
                this.changeTerm(termBid);
            }, timeout);
            setTimeout(() => {
                this.changeSchool(schoolBid);
            }, timeout);
            setTimeout(() => {
                this.changeInstructor(instructorBid);
            }, timeout);
            setTimeout(() => {
                this.changeClass(classBid);
            }, timeout);
        },
        handleLinkClick(event) {
            if (!this.state.selectedStudentBid) {
                event.preventDefault();
            }
        },
        renderAutoLoadButton() {
            if (
                process.env.mockTermBid &&
                process.env.mockSchoolBid &&
                process.env.mockInstructorBid &&
                process.env.mockClassBid
            ) {
                return (
                    <button
                        key="autoload-button"
                        id="autoload-button"
                        className="cancel-student-profile"
                        onClick={(e) => this.autoloadOnClick()}
                    >
                        Autoload
                    </button>
                );
            }
        },
        render() {
            const isFamilyReport = this.props.location.pathname === '/family-report';
            const selectClass =
                'student-selection-dropdown' + (FeatureUtils.isIE() || FeatureUtils.isEdge() ? ' ie-hack' : '');
            const termDropdown = (
                <DropdownMenu
                    id="terms"
                    defaultOption="Select a roster term"
                    selectedOptionValue={this.state.selectedTermBid}
                    label="Term Rostered"
                    onChange={this.changeTerm}
                    optionList={this.state.terms}
                    elementValueFunction={(term) => term.get('businessIdentifier')}
                    elementDisplayFunction={(term) => term.get('name')}
                    classesDivWrapper="student-selection-entry"
                    classesLabel="student-selection-label"
                    classesSelect={selectClass}
                />
            );
            const schoolDropdown = (
                <DropdownMenu
                    id="schools"
                    defaultOption="Select a school"
                    selectedOptionValue={this.state.selectedSchoolBid}
                    label="School"
                    onChange={this.changeSchool}
                    optionList={this.state.schools}
                    elementValueFunction={(school) => school.get('bid')}
                    elementDisplayFunction={(school) => school.get('name')}
                    classesDivWrapper="student-selection-entry"
                    classesLabel="student-selection-label"
                    classesSelect={selectClass}
                />
            );
            const instructorDropdown = (
                <DropdownMenu
                    id="instructors"
                    defaultOption="Select an instructor"
                    selectedOptionValue={this.state.selectedInstructorBid}
                    label="Instructor"
                    onChange={this.changeInstructor}
                    optionList={this.state.instructors}
                    elementValueFunction={(instructor) => instructor.get('bid')}
                    elementDisplayFunction={(instructor) =>
                        `${instructor.get('lastName')}, ${instructor.get('firstName')}`
                    }
                    classesDivWrapper="student-selection-entry"
                    classesLabel="student-selection-label"
                    classesSelect={selectClass}
                />
            );
            const classDropdown = (
                <DropdownMenu
                    id="classes"
                    defaultOption="Select a class"
                    selectedOptionValue={this.state.selectedClassBid}
                    label="Class"
                    onChange={this.changeClass}
                    optionList={this.state.classes}
                    elementValueFunction={(c) => c.get('bid')}
                    elementDisplayFunction={(c) => c.get('name')}
                    classesDivWrapper="student-selection-entry"
                    classesLabel="student-selection-label"
                    classesSelect={selectClass}
                />
            );
            const studentDropdown = (
                <DropdownMenu
                    id="Student"
                    defaultOption="Select a student"
                    selectedOptionValue={this.state.selectedStudentBid}
                    label="Student"
                    onChange={this.changeStudent}
                    optionList={this.state.students}
                    elementValueFunction={(s) => s.get('studentBid')}
                    elementDisplayFunction={(s) => s.get('fullName')}
                    classesDivWrapper="student-selection-entry"
                    classesLabel="student-selection-label"
                    classesSelect={selectClass}
                />
            );

            const linkClasses = this.state.selectedStudentBid
                ? 'view-student-profile'
                : FeatureUtils.isIE() || FeatureUtils.isEdge()
                ? 'view-student-profile disabled ie-hack'
                : 'view-student-profile disabled';

            const familyReport = {
                header: 'Select options below for Family Report.',
                printButton: 'Print Family Report',
                cancelButton: 'Clear Selection',
                className: 'student-selection-title family-report',
            };

            const studentProfile = {
                header: 'CREATE STUDENT PROFILE REPORT',
                printButton: 'View Student Profile',
                cancelButton: 'Cancel',
                className: 'student-selection-title',
            };

            const dropDowns = {
                termDropdown: termDropdown,
                schoolDropdown: schoolDropdown,
                instructorDropdown: instructorDropdown,
                classDropdown: classDropdown,
                studentDropdown: studentDropdown,
            };

            const routeDictatedObj = isFamilyReport ? familyReport : studentProfile;
            const headerText =
                isFamilyReport && this.state.pageAlert.get('isActive') ? '\u00a0' : routeDictatedObj.header;

            const reportContainer = 'family-report-container';

            return (
                <main id="selection-content">
                    <ReactLoader loaded={this.state.profileCheckCompleted}>
                        <h1 key="student-selection-title" className={routeDictatedObj.className}>
                            {headerText}
                        </h1>
                        {!isFamilyReport ? (
                            <React.Fragment>
                                {termDropdown}
                                {schoolDropdown}
                                {instructorDropdown}
                                {classDropdown}
                                {studentDropdown}
                                <span key="before-button-space" className="student-selection-label" />
                                <Link
                                    id="student-profile-link"
                                    key="student-profile-link"
                                    to="/students/profile"
                                    state={{ studentBid: this.state.selectedStudentBid }}
                                    className={linkClasses}
                                    onClick={this.handleLinkClick}
                                >
                                    {routeDictatedObj.printButton}
                                </Link>
                                <button
                                    key="cancel-button"
                                    id="cancel-button"
                                    className="cancel-student-profile"
                                    onClick={(e) => Actions.roster.clearRosterData()}
                                >
                                    {routeDictatedObj.cancelButton}
                                </button>
                                {this.renderAutoLoadButton()}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className={reportContainer}>
                                    <FamilyReport
                                        dropDowns={dropDowns}
                                        selectedTermNumber={this.state.selectedTermNumber}
                                        clearSelectedStudents={this.state.clearSelectedStudents}
                                        setClearSelectedStudents={this.setClearSelectedStudents}
                                        classSelected={this.state.classSelected}
                                        selectedSubject={this.state.selectedSubject}
                                        selectedModule={this.state.selectedModule}
                                        selectedClass={this.state.selectedClass}
                                        students={this.state.students}
                                        currentStudentBid={this.state.selectedStudentBid}
                                        isSingleStudentMode={this.state.isSingleStudentMode}
                                        linkingStudies={this.state.linkingStudies}
                                        terms={this.state.terms}
                                        termsWithTestEvents={this.state.termsWithTestEvents}
                                        studentInfo={this.state.studentInfo}
                                        unsavedData={this.state.unsavedData}
                                        reportsQueueLink={this.state.reportsQueueLink}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                    </ReactLoader>
                </main>
            );
        },
    })
);
